class ConsoleRawStream {
  constructor(con = console) {
    this.console = con
  }

  // noinspection JSMethodCanBeStatic
  write(level, msg) {
    // eslint-disable-line class-methods-use-this
    switch (level.toUpperCase()) {
      case 'DEBUG':
        this.console.debug(msg) // eslint-disable-line no-console
        break
      case 'INFO':
        this.console.info(msg) // eslint-disable-line no-console
        break
      case 'WARN':
        this.console.warn(msg) // eslint-disable-line no-console
        break
      case 'ERROR':
        this.console.error(msg) // eslint-disable-line no-console
        break
      default:
        this.console.log(msg) // eslint-disable-line no-console
        break
    }
  }
}

export default ConsoleRawStream
